import PrivacyPolicyContent from "./privacy_policy.mdx";
export default function PrivacyPolicy() {
  return (
    <div>
      <PrivacyPolicyContent />
    </div>
  );
}
